import { useEffect, useState } from "react";
import { Copy, Download, ExternalLink, Printer } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { qrDataUrl, downloadQr, printPoster, copyText } from "@/lib/qr";
import { toast } from "sonner";

export function QrImage({ url, size = 160, className = "", testId }) {
  const [src, setSrc] = useState("");
  useEffect(() => { qrDataUrl(url, size * 2).then(setSrc).catch(() => setSrc("")); }, [url, size]);
  if (!src) return <div style={{ width: size, height: size }} className="rounded bg-muted animate-pulse" />;
  return <img src={src} alt="QR Code" width={size} height={size} className={`rounded bg-white p-1 ${className}`} data-testid={testId} />;
}

const safe = (fn) => async () => { try { await fn(); } catch { toast.error("Não foi possível gerar o QR Code"); } };

export function LinkQrCard({ icon: Icon, title, desc, url, file, poster, testId }) {
  const copy = async () => { await copyText(url); toast.success("Link copiado"); };
  return (
    <div className="card-surface p-5 flex flex-col sm:flex-row gap-5" data-testid={testId}>
      <QrImage url={url} size={168} className="self-center shrink-0 border" testId={`${testId}-qr`} />
      <div className="flex-1 min-w-0 space-y-3">
        <div>
          <p className="font-semibold flex items-center gap-2"><Icon className="h-4 w-4 text-primary" />{title}</p>
          <p className="text-sm text-muted-foreground">{desc}</p>
        </div>
        <Input readOnly value={url} onFocus={(e) => e.target.select()} className="font-mono text-xs" data-testid={`${testId}-url`} />
        <div className="flex flex-wrap gap-2">
          <Button size="sm" onClick={copy} data-testid={`${testId}-copy`}><Copy className="h-4 w-4 mr-1" />Copiar link</Button>
          <Button size="sm" variant="outline" onClick={safe(() => downloadQr(url, file))} data-testid={`${testId}-download`}><Download className="h-4 w-4 mr-1" />Baixar QR Code</Button>
          <Button size="sm" variant="outline" onClick={safe(() => printPoster({ ...poster, url }))} data-testid={`${testId}-poster`}><Printer className="h-4 w-4 mr-1" />Imprimir cartaz</Button>
          <Button size="sm" variant="ghost" asChild><a href={url} target="_blank" rel="noreferrer" data-testid={`${testId}-open`}><ExternalLink className="h-4 w-4 mr-1" />Abrir</a></Button>
        </div>
      </div>
    </div>
  );
}

export function SmallQr({ title, url, file, testId }) {
  return (
    <div className="card-surface p-4 flex flex-col items-center gap-2 text-center break-inside-avoid" data-testid={testId}>
      <p className="font-semibold text-sm">{title}</p>
      <QrImage url={url} size={140} />
      <a href={url} target="_blank" rel="noreferrer" className="text-[10px] text-muted-foreground break-all">{url}</a>
      <Button size="sm" variant="ghost" className="print:hidden h-7 text-xs" onClick={safe(() => downloadQr(url, file))} data-testid={`${testId}-download`}><Download className="h-3.5 w-3.5 mr-1" />Baixar</Button>
    </div>
  );
}
